import(/* webpackMode: "eager" */ "/var/www/html/Ariel/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/var/www/html/Ariel/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/var/www/html/Ariel/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/var/www/html/Ariel/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/var/www/html/Ariel/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Playfair_Display\",\"arguments\":[{\"variable\":\"--font-playfair\",\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"600\",\"700\",\"800\",\"900\"],\"style\":[\"normal\",\"italic\"],\"display\":\"swap\"}],\"variableName\":\"playfair\"}");
;
import(/* webpackMode: "eager" */ "/var/www/html/Ariel/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/var/www/html/Ariel/src/app/providers.tsx");
